import React from "react";
import BlogInfo from "./BlogInfo";
import classNames from "classnames";

export default function ArticleDetails(props) {
  const [BlogData] = BlogInfo.map(item =>
    props.location.pathname === item.link ? item : "fail"
  ).filter(checkNull);
  function checkNull(arr) {
    return arr !== "fail";
  }
  function createMarkup() {
    return { __html: BlogData.description };
  }

  function MyComponent() {
    return (
      <p className="text-justify" dangerouslySetInnerHTML={createMarkup()} />
    );
  }

  return (
    <React.Fragment>
      {window.scrollTo(0, 0)}
      <div
        className={classNames(
          "parallax d-flex justify-content-center align-items-center col-12",
          BlogData.parallax
        )}
      />
      <div className="container">
        <h1 className="text-center text-bold my-2">{BlogData.title}</h1>
        <div className="d-flex justify-content-around">
          <p>By {BlogData.autor}. </p>
          <p className="">Date: {BlogData.date}</p>
        </div>
        <article className="latest-paragraph">{MyComponent()}</article>
      </div>
    </React.Fragment>
  );
}
